import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  CheckboxStatus,
  ModalRef,
  ModalModule,
  IconV2Module,
  InputV2Module,
  CheckboxV2Module,
  ButtonV2Module,
} from '@schenck/rotec-components';
import { MODAL_WIDTH } from 'src/utils/constants/modal.const';
import { TranslatePipe } from '@ngx-translate/core';

export interface LocationData {
  angle: number;
  restricted: boolean;
  side: 'left' | 'right';
}

export interface LocationModalData {
  side: 'left' | 'right';
  location?: LocationData;
}

@Component({
  selector: 'add-edit-location-modal',
  templateUrl: './add-edit-location-modal.component.html',
  styleUrls: ['./add-edit-location-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalModule,
    IconV2Module,
    InputV2Module,
    CheckboxV2Module,
    ButtonV2Module,
    TranslatePipe,
  ],
})
export class AddEditLocationModalComponent {
  public modalRef = inject<ModalRef<LocationModalData>>(ModalRef);

  public width: string = MODAL_WIDTH;
  public title: string;
  public showDeleteButton: boolean;

  public angleValue: number = null;
  public restrictedValue: CheckboxStatus = 'unchecked';
  public valid: boolean = false;

  private side: 'left' | 'right';

  constructor() {
    this.side = this.modalRef.data.side;
    this.title = this.modalRef.data.location ? 'Edit Location' : 'Add Location';
    this.showDeleteButton = !!this.modalRef.data.location;

    if (this.modalRef.data.location) {
      this.angleValue = this.modalRef.data.location.angle;
      this.restrictedValue = this.modalRef.data.location.restricted ? 'checked' : 'unchecked';
      this.validate(this.angleValue);
    }
  }

  public validate(number: number) {
    this.valid = typeof number === 'number' && number >= 0 && number <= 360;
    this.angleValue = number;
  }

  public save(): void {
    const result: LocationData = {
      angle: this.angleValue,
      restricted: this.restrictedValue === 'checked',
      side: this.side,
    };
    const noEmit: boolean =
      this.modalRef.data.location &&
      result.angle === this.modalRef.data.location?.angle &&
      result.restricted === this.modalRef.data.location?.restricted;

    this.modalRef.emitAndClose(!noEmit ? result : null);
  }

  public cancel(): void {
    this.modalRef.close();
  }

  public deleteLocation(): void {
    this.modalRef.emitAndClose('Delete');
  }
}
